import { library } from '@fortawesome/fontawesome-svg-core'

import { faCheck, faStarOfLife } from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add( faCheck, faStarOfLife )

export default FontAwesomeIcon